<template>
  <div class="radio-button" @click="emitToParent">
    <div class="v-input--selection-controls__input" :class="item.checked ? 'selected' : 'notselected'">
      <i aria-hidden="true" class="v-icon notranslate mdi mdi-radiobox-marked theme--light primary--text"></i>
    </div>
    <label class="v-label theme--light" :class="item.checked ? 'selected' : 'notselected'">{{ item.title }}</label>
    <p>{{ item.text }}</p>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'RadioButton',
  props: {
    item: Object,
    index: Number
  },
  methods: {
    emitToParent() {
      this.$emit('selected', this.item, this.index);
    }
  }
});
</script>

<style lang="scss">
.v-input--radio-group__input .radio-button {
  margin-bottom: 20px;
  cursor: pointer;
}
.v-input--radio-group__input .v-input--selection-controls__input {
  display: inline-block;
}
.v-input--radio-group__input .v-label {
  display: inline-block;
  margin-bottom: 10px;
}
.v-input--radio-group__input .v-label.notselected {
  display: inline-block;
  line-height: 26px;
}
.v-input--radio-group__input .v-label.selected {
  display: inline-block;
  font-weight: 800;
  color: black;
  line-height: 26px;
}
.v-input--radio-group__input .v-input--selection-controls__input.notselected {
  .mdi-radiobox-marked::before {
    color: #8a8a8a;
  }
  .v-icon::before {
    opacity: 0.2;
    content: '\F43D';
  }
}
</style>

<i18n src="../../localization/texts.json"></i18n>
